<template>
  <div class="post-content">
    <div class="row row--flex">
      <div class="col-70">
        <p>Pamiętasz czasy, w których na ekologię mówiliśmy „środowisko”? Teraz chwila na refleksję o naszym środowisku i najbliższym otoczeniu. Jeśli tylko masz taką możliwość, staraj się drukować lokalnie i wspierać miejscową produkcję. Wiele mówiliśmy o tym, jak Twoje decyzje – wybór technologii czy papieru wpływają na to, jak zrównoważona jest Twoja produkcja. Ale na jej ostateczny kształt największy wpływ i tak ma drukarz. Drukarz, który doradzi Ci wybór papieru i wydruk z niestandardowego profilu (np. RGB lub profilu ICC danego papieru) i zaopiekuje się Twoją produkcją.</p>
      </div>
      <Sidenote class="col-30">
        <p>Znalezienie zaufanego drukarza nie jest prostą sprawą, ale zachęcam, by podjąć tę próbę.</p>
      </Sidenote>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p
          class="indend-left highlighted-text"
        >Znalezienie zaufanego drukarza nie jest prostą sprawą, ale zachęcam, by podjąć tę próbę. W idealnej sytuacji znajdziesz drukarza w swojej miejscowości, będziesz mógł się z nim spotkać, obejrzeć druki czy odebrać je osobiście. Jeśli to niemożliwe, poszukaj odpowiednich drukarzy w nieco dalszym sąsiedztwie, do których będziesz mógł podjechać rowerem (w przypadku mniejszych produkcji lub odbioru prób drukarskich) lub skorzystaj z tych znajdujących się na trasie Twoich wizyt w innym mieście lub wysyłających wydruki w możliwie zrównoważony sposób.</p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p>Przy zlecaniu produkcji z przesyłką warto zapytać drukarnię o opakowanie neutralne klimatycznie. Pamiętajmy, drukarnia to miejsce, w którym zazwyczaj znajduje się dużo odpadu papierowego, ścinków i w której znajduje się mnóstwo alternatyw dla plastikowych wypełniaczy czy folii bąbelkowej. Zamieniając dodatkowo taśmę plastikową na papierową uzyskujemy dobrą alternatywę dla nieekologicznych przesyłek z drukami.</p>
      </div>
      <div class="col-30">
        <RelatedPosts :currentPostID="postID" />
      </div>
    </div>
    <ScrollToTop />
  </div>
</template>

<script>
import RelatedPosts from "../RelatedPosts";
import ScrollToTop from "../ScrollToTop";
import Sidenote from "../Sidenote";

export default {
  name: "Post5",
  components: {
    RelatedPosts,
    ScrollToTop,
    Sidenote
  },
  props: {
    postID: Number
  }
};
</script>

<style lang="scss">
</style>